<template lang="html">
  <div class="ui-choose-wrapper">
    <calendar initial="1" v-on:choose="chooseDate"></calendar>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import calendar from '@/components/calendar'

export default {
  components: {
    calendar
  },
  computed: {
    ...mapState(['filterLevel'])
  },
  methods: {
    ...mapMutations(['setFilterTime', 'hideActionSheet']),
    chooseDate(val) {
      this.setFilterTime(val.ymd || '')
      this.hideActionSheet(false)
    }
  },
  created() {}
}
</script>
<style lang="scss" scoped>
@import '../../../assets/css/mixin';
.ui-choose-wrapper {
  position: relative;
  height: 100%;
}
</style>
